<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="baseRect">
      <van-row gutter="10">
        <van-col span="12">
          <span>日期</span>
          <div class="inputRect" @click="onSelectDate">
            <div class="van-cell van-field input">
              {{ formatDate(dataForm.dateOfStar,"yyyy/MM/dd") }}
            </div>
          </div>

          <span>国家</span>
          <div class="inputRect">
            <van-field v-model="dataForm.country" readonly class="input" @click="onCountryPicker" />
          </div>
          <span>潜店</span>
          <div class="inputRect">
            <van-field v-model="dataForm.shopName" class="input" />
          </div>

          <span>入水时间</span>
          <div class="inputRect" @click="onSelectTime">
            <div class="van-cell van-field input">
              {{ formatDate(dataForm.dateOfStar,"hh:mm") }}
            </div>
          </div>
          <span>潜水类型</span>
          <div class="inputRect">
            <div class="van-cell van-field input" @click="onShowConfrimDiveType">
              {{ GetEnumText('Em_DiveType',dataForm.diveType) }}
            </div>
          </div>
          <span>日志主题</span>
          <div class="inputRect">
            <van-field v-model="selectStyle.name" readonly class="input" @click="onStylePicker" />
          </div>
        </van-col>
        <van-col span="12">
          <span>天气</span>
          <div class="inputRect selectRect">
            <div
              v-for="item in weatherList"
              :key="item"
              class="icon"

              @click="onSelectWeather(item)"
            >
              <i :class="'iconfont icon'+item" :style="dataForm.weather===item?'color:'+GetDiveMainBack():'color:#999'" />
            </div>
          </div>

          <span>地区</span>
          <div class="inputRect">
            <van-field v-model="dataForm.areaName" class="input" />
          </div>
          <span>潜点</span>
          <div class="inputRect">
            <van-field v-model="dataForm.divePlaceName" class="input" />
          </div>

          <span>潜水时间(分钟)</span>
          <div class="inputRect">
            <van-field v-model="dataForm.dateOfLen" readonly class="input" @click="showDiveLen=true" />
          </div>
          <span>私密日志</span>
          <div class="inputSwitch">
            <van-switch v-model="dataForm.isPrivate" size="1.9em" />
          </div>
        </van-col>
      </van-row>
    </div>

    <div class="baseRect">
      <van-row gutter="10">
        <van-col span="12">
          <span>最大深度(米)</span>
          <div class="inputRect">
            <van-field v-model="dataForm.maxDeep" readonly class="input" @click="showDivemaxDeep=true" />
          </div>
          <span>能见度(米)</span>
          <div class="inputRect">
            <van-field v-model="dataForm.visibility" readonly class="input" @click="showDivevisibility=true" />
          </div>
        </van-col>
        <van-col span="12">
          <span>平均深度(米)</span>
          <div class="inputRect">
            <van-field v-model="dataForm.avgDeep" readonly class="input" @click="showDiveavgDeep=true" />
          </div>
          <span>水域温度(摄氏度)</span>
          <div class="inputRect">
            <van-field v-model="dataForm.temparature" readonly class="input" @click="showDivetemparature=true" />
          </div>
        </van-col>
      </van-row>
    </div>

    <div class="baseRect">
      <span>添加照片</span>
      <div class="uploadRect">
        <van-uploader
          v-model="fileList"
          multiple
          :max-count="100"
          :after-read="afterRead"
        />
      </div>
      <span>日志内容</span>
      <van-field
        v-model="dataForm.about"
        style="padding:0.5em 0 1em 0;"
        rows="3"
        autosize
        type="textarea"
        maxlength="2048"
        placeholder="请输入日志内容"
        show-word-limit
      />
    </div>
    <div class="emptyRect" />
    <div class="buttonRect">
      <van-row v-if="!isNew" class="buttons">
        <van-col span="12"><van-button :loading="buttonLoading" type="primary" round size="small" style="width:calc(100% - 0.5em);" :color="GetColorSecondary()" @click="onDelete">删除</van-button></van-col>
        <van-col span="12"><van-button :loading="buttonLoading" type="primary" round size="small" style="width:calc(100% - 0.5em);margin-left:0.5em;" :color="GetDiveMainBack()" @click="onEdit">修改</van-button></van-col>
      </van-row>
      <van-row v-if="isNew" class="buttons">
        <van-button :loading="buttonLoading" type="primary" round size="small" style="width:100%;" :color="GetDiveMainBack()" @click="onEdit">添加</van-button>
      </van-row>
    </div>

    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker
        v-model="dateOfStar"
        type="datetime"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="showDatePicker=false"
        @confirm="onConfrimDate"
      />
    </van-popup>
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="timeStart"
        type="time"
        @cancel="showTimePicker=false"
        @confirm="onConfrimTime"
      />
    </van-popup>
    <van-popup v-model="showCountryPicker" position="bottom">
      <van-picker
        show-toolbar
        title="选择国家"
        :columns="countyList"
        :loading="loadingCounty"
        @cancel="showCountryPicker=false"
        @confirm="onConfrimCountry"
      />
    </van-popup>
    <van-popup v-model="showStylePicker" position="bottom">
      <van-picker
        show-toolbar
        title="选择日志主题"
        value-key="name"
        :columns="styleList"
        :default-index="styleSelectIndex"
        @cancel="showStylePicker=false"
        @confirm="onConfrimStyle"
      />
    </van-popup>
    <van-popup v-model="showDiveTypePicker" position="bottom">
      <van-picker
        show-toolbar
        title="选择潜水类型"
        value-key="text"
        :columns="diveTypeList"
        :default-index="diveTypeSelectIndex"
        @cancel="showDiveTypePicker=false"
        @confirm="onConfrimDiveType"
      />
    </van-popup>
    <van-number-keyboard
      v-model="dataForm.dateOfLen"
      close-button-text="完成"
      title="潜水时长(分钟)"
      :show="showDiveLen"
      :maxlength="3"
      @blur="showDiveLen = false"
    />
    <van-number-keyboard
      v-model="dataForm.maxDeep"
      close-button-text="完成"
      title="最大深度(米)"
      extra-key="."
      :show="showDivemaxDeep"
      :maxlength="5"
      @blur="showDivemaxDeep = false"
    />
    <van-number-keyboard
      v-model="dataForm.visibility"
      close-button-text="完成"
      title="能见度(米)"
      extra-key="."
      :show="showDivevisibility"
      :maxlength="5"
      @blur="showDivevisibility = false"
    />
    <van-number-keyboard
      v-model="dataForm.avgDeep"
      close-button-text="完成"
      title="平均深度(米)"
      extra-key="."
      :show="showDiveavgDeep"
      :maxlength="5"
      @blur="showDiveavgDeep = false"
    />
    <van-number-keyboard
      v-model="dataForm.temparature"
      close-button-text="完成"
      title="水域温度(摄氏度)"
      extra-key="."
      :show="showDivetemparature"
      :maxlength="5"
      @blur="showDivetemparature = false"
    />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Uploader, DatetimePicker, Popup, NumberKeyboard, Picker, Dialog, Switch } from 'vant'
import TopBar from '@/components/TopBar'
import { GetEnumList, MyNotify, ShowMoney, GetEnumText, formatDate, compressorImageList } from '@/utils/base'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [NumberKeyboard.name]: NumberKeyboard,
    [Picker.name]: Picker,
    [Dialog.Component.name]: Dialog.Component,
    [Switch.name]: Switch,
    TopBar
  },
  data() {
    return {
      isNew: true,
      titleTop: '',
      title: '编辑潜水日志',
      backurl: '/dive/logList',
      value: undefined,
      message: '',
      fileList: [],
      countyList: [],
      styleList: [],
      styleSelectIndex: 0,
      selectStyle: {
        name: '默认',
        styleId: '',
        sort: 9999,
        backColor: '#f1f1f1',
        dataColor: '#fff',
        dataBackColor: '#fff',
        fontMainColor: '#fff',
        fontAttributeColor: '#999',
        fontBodyColor: '#000',
        lineColor: '#fff',
        rectRGBA: '255,255,255,1'
      },
      buttonLoading: false,
      weatherList: ['sky2', 'sky1', 'sky4', 'sky3'],
      diveTypeList: [],
      diveTypeSelectIndex: undefined,
      id: undefined,
      minDate: new Date(1900, 1, 1),
      maxDate: new Date(),
      showDatePicker: false,
      showTimePicker: false,
      showDiveLen: false,
      showDivemaxDeep: false,
      showDivevisibility: false,
      showDiveavgDeep: false,
      showDivetemparature: false,
      showCountryPicker: false,
      showStylePicker: false,
      showDiveTypePicker: false,
      loadingCounty: true,
      dateOfStarSave: undefined,
      dateOfStar: undefined,
      timeStart: undefined,
      dataForm: {
        diveLogId: undefined,
        dateOfStar: new Date(),
        dateOfLen: '',
        weather: 'iconrigthjt',
        country: '',
        about: '',
        styleId: '',
        isPrivate: false,
        diveType: 'SCUBA'
      }
    }
  },
  created() {
    this.diveTypeList = GetEnumList('Em_DiveType')
    this.styleList.push(this.selectStyle)
    this.maxDate = new Date(this.maxDate.setDate(this.maxDate.getDate() + 1))
    console.log('this.maxDate', this.maxDate)
    this.titleTop = GetDiveTitle()
    this.id = this.$route.params.id
    this.isNew = !this.id || this.id === '0' || this.id === 0
    this.loadStyle(() => {
      if (!this.isNew) {
        this.init()
      }
    })
  },
  methods: {
    MyNotify,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    init() {
      request({
        url: '/Dive/getDiveLogEntity',
        method: 'post',
        params: { id: this.id }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.dataForm = response.data
        this.dataForm.dateOfStar = new Date(this.dataForm.dateOfStar)
        this.dataForm.dateOfLen += ''
        this.dataForm.maxDeep += ''
        this.dataForm.visibility += ''
        this.dataForm.temparature += ''
        this.dataForm.avgDeep += ''
        // 处理上传图片
        if (this.dataForm.res) {
          this.fileList = []
          var resList = this.dataForm.res.split(',')
          resList.forEach(item => {
            this.fileList.push({
              url: item
            })
          })
        }
        // 处理风格
        if (this.dataForm.styleId) {
          var i = 0
          this.styleList.forEach(item => {
            if (item.styleId === this.dataForm.styleId) {
              this.selectStyle = item
              this.styleSelectIndex = i
            }
            i++
          })
        }
      })
    },
    afterRead(file) {
      console.log('file', file)
    },
    onSelectDate() {
      this.dateOfStar = this.dataForm.dateOfStar
      this.showDatePicker = true
    },
    onConfrimDate() {
      this.dataForm.dateOfStar = this.dateOfStar
      this.showDatePicker = false
    },
    onSelectTime() {
      this.timeStart = formatDate(this.dataForm.dateOfStar, 'hh:mm')
      this.showTimePicker = true
    },
    onConfrimTime() {
      if (!this.timeStart) {
        return
      }
      console.log(this.timeStart)
      var ls = this.timeStart.split(':')
      this.dataForm.dateOfStar.setHours(ls[0], ls[1])
      this.showTimePicker = false
    },
    onSelectWeather(select) {
      this.dataForm.weather = select
    },
    onStylePicker() {
      if (this.styleList.length <= 1) {
        this.loadStyle()
      }
      this.showStylePicker = true
    },
    onDiveType() {

    },
    loadStyle(callback) {
      request({
        url: '/Dive/getDiveLogStyleList',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.styleList = response.data
        this.styleList.unshift(this.selectStyle)
        if (callback) {
          callback()
        }
      })
    },
    onConfrimStyle(select) {
      console.log('onConfrimStyle', select)
      this.selectStyle = select
      this.dataForm.styleId = select.styleId
      this.showStylePicker = false
    },
    onCountryPicker() {
      if (this.countyList.length <= 0) {
        this.loadCountry()
      }
      this.showCountryPicker = true
    },

    loadCountry() {
      this.loadingCounty = true
      request({
        url: '/DiveData/diveCountryList',
        method: 'post',
        params: { haveRecommend: true }
      }).then(response => {
        this.loadingCounty = false
        if (!response.success) {
          return
        }
        this.countyList = response.data
      })
    },
    getCountryValue(text) {
      var result
      this.countyList.forEach(group => {
        group.children.forEach(country => {
          if (country.text === text) {
            result = country.value
            return
          }
        })
      })
      return result
    },
    onShowConfrimDiveType() {
      var index = 0
      this.diveTypeList.forEach(el => {
        if (el.value === this.dataForm.diveType) {
          this.diveTypeSelectIndex = index
        }
        index++
      })
      this.showDiveTypePicker = true
    },
    onConfrimDiveType(select) {
      this.dataForm.diveType = select.value
      this.showDiveTypePicker = false
    },
    onConfrimCountry(select) {
      console.log('select', select)
      this.dataForm.country = this.getCountryValue(select[1])
      console.log('country', this.dataForm.country)
      this.showCountryPicker = false
    },
    uploadImg(callback) {
      var noFile = true
      var fileList = []
      this.fileList.map((value, index, array) => {
        if (value.file) {
          fileList.push(value.file)
          noFile = false
        }
      })
      if (noFile) {
        if (callback) {
          var list = []
          this.fileList.map(value => {
            list.push(value.url)
          })
          callback(list.toString())
        }
        return
      }
      compressorImageList(fileList, 1024, 1024, 0.6, (list) => {
        const formData = new FormData()
        list.map((value, index, array) => {
          if (value.name) {
            formData.append('file', value.file, value.name)
          } else {
            formData.append('file', value.file)
          }
        })
        request({
          url: '/Data/uploadFile?config=divelog',
          method: 'post',
          data: formData
        }).then(response => {
          console.log('上传图片反馈', response)
          if (!response.success) {
            this.buttonLoading = false
            return
          }
          var list = []
          this.fileList.map(value => {
            if (!value.file) {
              list.push(value.url)
            }
          })
          response.data.map((value, index, array) => {
            list.push(value.save)
          })
          if (callback) {
            callback(list.toString())
          }
        })
      })
    },
    onEdit() {
      this.buttonLoading = true
      this.dataForm.dateOfStar = formatDate(this.dataForm.dateOfStar, 'yyyy/MM/dd hh:mm:ss')
      this.uploadImg((imgStr) => {
        console.log('uploadImg', imgStr)
        this.dataForm.res = imgStr
        request({
          url: '/Dive/updateDiveLog',
          method: 'post',
          data: this.dataForm
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          MyNotify('success', '提交成功')
          window.history.length > 1
            ? this.$router.go(-1)
            : this.$router.push(this.backUrl)
        })
      })
    },
    onDelete() {
      Dialog.confirm({
        title: '删除潜水日志',
        message: '确认删除这条潜水日志?'
      }).then(() => {
        if (this.buttonLoading) {
          return
        }
        this.buttonLoading = true
        request({
          url: '/Dive/deleteDiveLog',
          method: 'post',
          data: { ids: [this.id] }
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          MyNotify('success', '删除成功')
          window.history.length > 2
            ? this.$router.go(-2)
            : this.$router.push('/dive/logList')
        })
      })
    }
  }
}
</script>
<style scoped>
.baseRect{
    background-color: #fff;
    padding: 1em 1em 0 1em;
    margin-bottom: 0.5em;
}
.baseRect span{
    font-size: 0.8em;
    color: #999;
}
.baseRect .inputRect{
    margin: 0.5em 0 1em 0;
    background-color:#eee;
    border-radius: 2em;
    height: 2em;
    padding: 0 0.8em;
    line-height: 2em;
}
.baseRect .inputSwitch{
   margin: 0.5em 0 1em 0;
}
.baseRect .inputRect .input{
    padding: 0;
    background-color:transparent;
    line-height: 2em;
    height: 2em;
}
.baseRect .selectRect{
    background-color:#fff;
    padding:0;
}
.baseRect .selectRect .icon{
    width: 2em;
    height: 2em;
     text-align: center;
     float: left;
      margin-right: 0.2em;
       color: #999;
    /* color: #fff;
    background-color: #999;
    float: left;
    text-align: center;
    border-radius: 2em;
    margin-right: 0.2em; */
}
.baseRect .selectRect .icon i{
  font-size: 2em;
}
.uploadRect{
    padding-bottom: 0.5em;
    margin: 0.5em 0 1em 0;
    border-bottom: 1px solid #f5f5f5;
}

.emptyRect{
    height: 4em;
}
.buttonRect{
    position: fixed;
    left: 0;
    bottom: 0;
    height: 4em;
    width: 100%;
    border-top: 1px solid #f5f5f5;
    background-color: #fff;
}
.buttonRect .buttons{
    padding: 1em 1em;
}
</style>
